var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTestTubeLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 1.33301V2.66634H10.667V11.9997C10.667 13.4724 9.47306 14.6663 8.00033 14.6663C6.52757 14.6663 5.33366 13.4724 5.33366 11.9997V2.66634H4.66699V1.33301H11.3337ZM9.33366 6.66634H6.66699V11.9997C6.66699 12.7361 7.26393 13.333 8.00033 13.333C8.73673 13.333 9.33366 12.7361 9.33366 11.9997V6.66634ZM8.66699 9.99967C9.03519 9.99967 9.33366 10.2981 9.33366 10.6663C9.33366 11.0345 9.03519 11.333 8.66699 11.333C8.29879 11.333 8.00033 11.0345 8.00033 10.6663C8.00033 10.2981 8.29879 9.99967 8.66699 9.99967ZM7.33366 7.99967C7.70186 7.99967 8.00033 8.29814 8.00033 8.66634C8.00033 9.03454 7.70186 9.33301 7.33366 9.33301C6.96546 9.33301 6.66699 9.03454 6.66699 8.66634C6.66699 8.29814 6.96546 7.99967 7.33366 7.99967ZM9.33366 2.66634H6.66699V5.33301H9.33366V2.66634Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTestTubeLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/test-tube-line.66cba8a1.svg";
export { ForwardRef as ReactComponent };